// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"379c7067","455":"b7f18ec9","977":"ec6e09f2"}[chunkId] + ".chunk.js";
};